import { convertRangeClamped } from "@/components/CameraControl";
import { CONFIG } from "@/config";
import { atom } from "jotai";
import { Zoom } from "./camera";
var DEFAULT_VOLUME = 0.5;
var TargetMusicVolumeAtom = atom({
    volume: DEFAULT_VOLUME,
    muted: false,
});
var TargetSfxVolumeAtom = atom({ volume: DEFAULT_VOLUME, muted: false });
var ZoomControlledVolumesAtom = atom(CONFIG.zoomControlledVolumeEnabled);
export var EffectiveMusicVolumeAtom = atom(function (get) {
    var volumeState = get(TargetMusicVolumeAtom);
    if (volumeState.muted)
        return 0;
    return get(ZoomControlledVolumesAtom)
        ? volumeState.volume * convertRangeClamped(get(Zoom), [0, 0.8], [1, 0.2])
        : volumeState.volume;
});
export var EffectiveSfxVolumeAtom = atom(function (get) {
    var volumeState = get(TargetSfxVolumeAtom);
    if (volumeState.muted)
        return 0;
    return get(ZoomControlledVolumesAtom)
        ? volumeState.volume * convertRangeClamped(get(Zoom), [0, 0.8], [0.1, 1])
        : volumeState.volume;
});
export var MusicVolumeAtom = atom(function (get) {
    return get(TargetMusicVolumeAtom);
}, function (get, set, value) {
    if ("muted" in value) {
        var current = get(TargetMusicVolumeAtom);
        if (!value.muted && current.volume === 0) {
            set(TargetMusicVolumeAtom, { muted: false, volume: DEFAULT_VOLUME });
        }
        else {
            set(TargetMusicVolumeAtom, {
                muted: value.muted,
                volume: current.volume,
            });
        }
    }
    else {
        if (value.volume === 0) {
            set(TargetMusicVolumeAtom, { muted: true, volume: 0 });
        }
        else {
            set(TargetMusicVolumeAtom, {
                muted: false,
                volume: value.volume,
            });
        }
    }
    set(ZoomControlledVolumesAtom, false);
});
export var SfxVolumeAtom = atom(function (get) {
    return get(TargetSfxVolumeAtom);
}, function (get, set, value) {
    if ("muted" in value) {
        var current = get(TargetSfxVolumeAtom);
        if (!value.muted && current.volume === 0) {
            set(TargetSfxVolumeAtom, { muted: false, volume: DEFAULT_VOLUME });
        }
        else {
            set(TargetSfxVolumeAtom, {
                muted: value.muted,
                volume: current.volume,
            });
        }
    }
    else {
        if (value.volume === 0) {
            set(TargetSfxVolumeAtom, { muted: true, volume: 0 });
        }
        else {
            set(TargetSfxVolumeAtom, {
                muted: false,
                volume: value.volume,
            });
        }
    }
    set(ZoomControlledVolumesAtom, false);
});
